import React, { Component } from 'react'

const Option = (props) => {
    return (
        <button className="dropdown-item" {...props}>
            {!!props.icon && <i className={props.icon}></i>} {props.label}
        </button>
    )
}

class DropdownButton extends Component {
    render() {
        return (
            <div className="btn-group">
                {this.props.label &&
                    <button
                        type="button" onClick={this.props.onActionClick}
                        className="btn btn-light waves-effect waves-light">
                        {!!this.props.icon &&
                            <i className={this.props.icon}></i>
                        } {this.props.label}
                    </button>
                }
                <button type="button" className="btn btn-light dropdown-toggle waves-effect waves-light" data-toggle="dropdown" aria-expanded="false">
                    <span className="caret"></span>
                </button>
                <div className="dropdown-menu" x-placement="bottom-start">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

DropdownButton.Option = Option;
DropdownButton.defaultProps = {
    label: '',
    icon: '',
    options: [],
    onActionClick(){}
};

export default DropdownButton;


// WEBPACK FOOTER //
// ./src/components/DropdownButton.js